import { render, staticRenderFns } from "./BoardingLines.vue?vue&type=template&id=7fab89f4&scoped=true"
import script from "./BoardingLines.vue?vue&type=script&lang=js"
export * from "./BoardingLines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab89f4",
  null
  
)

export default component.exports